module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_5012.40a8773a.png";